"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = void 0;
var Constants = /** @class */ (function () {
    function Constants() {
    }
    Constants.ErrorGettingProducts = "Error getting product data. Please reload the page";
    Constants.ErrorGettingCategories = "Error getting SubCategories. Please reload the page";
    Constants.ErrorGettingBrands = "Error getting Brands. Please reload the page";
    Constants.ErrorGettingFeatures = "Error getting Brands. Please reload the page";
    Constants.ExpirationDaysBookMarkedProducts = 7;
    Constants.CookiePrefixBookmarkedProducts = "marked-products";
    Constants.ErrorGettingMarkedProducts = "Error getting marked products. Please reload the page";
    Constants.ErrorGettingProductDetail = "Error getting product detail. Please reload the page";
    Constants.ErrorSendContactForm = "Es gab ein Problem beim Senden der Formulardaten. Biite versuchen Sie es erneut.";
    Constants.CorrectSentContactForm = "Ihre Anfrage wurde erfolgreich versendet. Wir werden uns umgehend um Ihr Anliegen kümmern und uns dazu bei Ihnen melden.";
    Constants.ProductDoesNotExistsHomePage = "Der angeforderte Artikel steht leider nicht mehr zur Verfügung. Bitte wählen sie eine Warengruppe aus und starten sie eine erneute Suche.";
    Constants.ProductDoesNotExistsBookMarkedPage = "Der gemerkte Artikel ist leider nicht mehr im Katalog vorhanden. Wollen sie den Artikel aus der Liste rausnehmen?";
    Constants.BadProductSearchParams = "Zu dieser Marke haben wir derzeit keine Produktangebote im Internet hinterlegt. Gerne beraten wir Sie in unserem Fachgeschäft.";
    return Constants;
}());
exports.Constants = Constants;
